import React, { useState,useEffect } from "react";
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import SelectDateOnly from "../components/popups/SelectDateOnly";

import { ChangeDateStringOnlyDate,ChangeDateFormat,isObjEmpty,ToggleDarkBackground,PassedMonths,ChangeSimpleDateString,
        isNull,GetChildrenState } from "../../components/common/Common";
import centerIcon from "../../img/icon/icon-center-class-03.svg";
import "../../css/style.css";

//수료증 발급신청
const CertificateOrder = () => {
  let { ch_idx } = useParams();
  const branch_idx = Number(localStorage.getItem('branch_idx'));

  const navigate = useNavigate();
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varChildrenLevelList,setChildrenLevelList] = useState([]);
  const [varChildrenInfo,setChildrenInfo] = useState({});
  const [varCertificationList,setCertificationList] = useState([]);

  //수료증 발급을 위한 원생정보 호출
  const GetChildrenForCertificate = async() => {
    const sendData = {ch_idx:ch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_children_certificate`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //원생정보 + 발급정보
        const childrenData = datas.childrens[0];
        setChildrenInfo(childrenData);

        //원생이 발급 가능한 등급 목록
        const ch_level = childrenData.ch_level;
        const levelList = datas.levels;
        const selectLevels = levelList.filter(el=>el.vl_idx <= ch_level);
        setChildrenLevelList(selectLevels);

        //원생에 대한 수료증 발급 목록
        setCertificationList(datas.certifications);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    //서버로부터 정보 호출
    GetChildrenForCertificate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //정보입력부
  const onChangeInputHandler = (e) => {
    let { name, value } = e.currentTarget;
    if(name === "vl_idx") {
      const ivalue = Number(value);
      if(ivalue > varChildrenInfo.ch_level) {
        alert('원생의 등급보다 높은 등급의 수료증은 발급할 수 없습니다.'); 
        return false;
      }
      const levelData = varChildrenLevelList.find(el=>el.vl_idx === ivalue);
      const termMonth = levelData.vl_terms * 12 - 1;
      const passMonth = PassedMonths(varChildrenInfo.ch_rdate);
      if(passMonth < termMonth) {
        alert(`원생의 등록기간(${passMonth}개월)이 수료증 발급의 조건(${termMonth}개월)보다 적어 수료증을 발급할 수 없습니다.`); 
        return false;
      }
      GetCertificateCode(ivalue);
    } else if(name === "ce_lang") {
      setChildrenInfo({...varChildrenInfo,[name]:Number(value)});
    } else {
      if(name === "ch_name"){
        if(varChildrenInfo.ce_lang === 2) name = "ch_ename"; 
      } else if(name === "bh_company") {
        if(varChildrenInfo.ce_lang === 2) name = "bh_ecompany"; 
      }
      setChildrenInfo({...varChildrenInfo,[name]:value});
    }
  }

  //수료증 발급번호 감지
  const GetCertificateCode = async(vl_idx) => {
    const sendData = {vl_idx:vl_idx,ch_idx:varChildrenInfo.ch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_certificate_code`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        let ce_code = datas.ce_code;
        //BASIC은 국문만
        if(vl_idx === 1)
          setChildrenInfo({...varChildrenInfo,vl_idx:vl_idx,ce_lang:1,ce_code:ce_code});
        else
          setChildrenInfo({...varChildrenInfo,vl_idx:vl_idx,ce_code:ce_code});
      } else {
        if(vl_idx === 1)
          setChildrenInfo({...varChildrenInfo,vl_idx:vl_idx,ce_lang:1});
        else
          setChildrenInfo({...varChildrenInfo,vl_idx:vl_idx});
      }
    });
  }

  //날짜선택 팝업창--------------------------------------------------------------------------------------
  const [varPopupDaySelect,setPopupDaySelect] = useState(false);  //팝업창 열기/닫기
  const [varDate,setDate] = useState(null); //선택된 날짜
  const onChangeDateHandler = (e) => {
    const csdate = varChildrenInfo.ce_idate;
    const sdate = new Date(csdate);
    setDate(sdate);
    /* //팝업창 위치조정
    const hasbtns = document.querySelectorAll('.has-btn');
    const toppos = hasbtns[0];
    const offsetY = window.pageYOffset+toppos.getBoundingClientRect().top - 100;
    const popupWin = document.querySelector('.layer-pop-select-date');
    popupWin.setAttribute('style',`top:${offsetY}px`); */
    //팝업창 호출
    TogglePopupDaySelect(true);
  }
  const TogglePopupDaySelect = (bmode) => {
    setPopupDaySelect(bmode);
    ToggleDarkBackground(bmode);
  }
  //팝업창 - 날짜 설정값 저장
  const ChangedDate = (date,iindex) => {
    console.log(iindex);
    if(date === "" ) date = null;
    const ndate = ChangeDateFormat(date);
    setChildrenInfo({...varChildrenInfo,ce_idate:ndate});
    TogglePopupDaySelect(false);
  }

  //발급신청 등록
  const onRegisterCertificateHandler = async(e) => {
    if(varChildrenInfo.vl_idx === 0) {
      alert('발급할 수료증의 대상을 선택하세요.'); return false;
    } else if(varChildrenInfo.ce_lang === 0) {
      alert('발급할 수료증의 언어를 선택하세요.'); return false;
    } else if(isNull(varChildrenInfo.ce_idate)) {
      alert('발급할 수료증의 희망발급일을 선택하세요.'); return false;
    } 
    if(varChildrenInfo.ce_lang===1) {
      if(varChildrenInfo.ch_name === 0) {
        alert('발급할 수료증의 원생명을 선택하세요.'); return false;
      } else if(varChildrenInfo.bh_company === 0) {
        alert('발급할 수료증의 센터명을 입력하세요.'); return false;
      }
    } else {
      if(varChildrenInfo.ch_ename === 0) {
        alert('발급할 수료증의 영문 원생명을 선택하세요.'); return false;
      } else if(varChildrenInfo.bh_ecompany === 0) {
        alert('발급할 수료증의 영문 센터명을 입력하세요.'); return false;
      }
    }

    //발급점검
    console.log(varCertificationList);
    const issueList = varCertificationList.filter(el=>el.vl_idx === varChildrenInfo.vl_idx && el.ce_status === 1);
    if(issueList.length > 0) {
      alert('이미 발급신청이 되어 있습니다.'); return false;
    }

    if(!window.confirm('수료증 발급을 신청하시겠습니까?')) return false;

    //발급이 이미 된 경우
    if(!isNull(varChildrenInfo.ce_code)) {
      RegisterCertificate(varChildrenInfo.ce_code);
    } else {
      //신규 발급코드 발행
      let today = new Date();
      let smonth = today.getFullYear().toString().slice(-2) + ('0' + (today.getMonth() + 1)).slice(-2);
      const sendData = {vl_idx:varChildrenInfo.vl_idx,smonth:smonth};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/branch_new_certificate_code`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          let cen_numbering = datas.cen_numbering;
          //console.log(varChildrenInfo.vl_idx);
          let levelData = varChildrenLevelList.find(el=>el.vl_idx === varChildrenInfo.vl_idx);
          let ce_code = levelData.vl_name.substr(0,1)+smonth+('00' + cen_numbering).slice(-3);
          //console.log(ce_code);
          RegisterCertificate(ce_code);
        } else {
          alert(datas.message);
        }
      });
    }
  }

  const RegisterCertificate = async(ce_code) => {
    const sendData = {ch_idx:ch_idx,bh_idx:branch_idx,dataInfo:varChildrenInfo,ce_code:ce_code};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_register_certificate`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        navigate(`/Branch/CertificatesSet`);
      }
    });
  }


  return isObjEmpty(varChildrenInfo) || isObjEmpty(varChildrenInfo)?null:(
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={'수료증 신청'} varBackString={'/Branch/CertificatesSet'}/>
      <div className="vh-content-body cl-certi-wrap">
        <div className="certi-form-wrap">
          <div className="center-wrap">
            <div className="certi-info">
              <div className="line">
                <div className="name">{varChildrenInfo.ch_name} {PassedMonths(varChildrenInfo.ch_birthday)+"개월"}</div>
                <div>{ChangeSimpleDateString(varChildrenInfo.ch_birthday)} ({GetChildrenState(varChildrenInfo.ch_status)})</div>
              </div>
              <ul>
                <li>
                  <p>출석회차</p>
                  <div>{varChildrenInfo.ch_attendance}회</div>
                </li>
                <li>
                  <p>듭급</p>
                  <div>{varChildrenInfo.vl_name}</div>
                </li>
                <li>
                  <p>등록일</p>
                  <div>{ChangeSimpleDateString(varChildrenInfo.ch_rdate)}</div>
                </li>
                <li>
                  <p>센터명</p>
                  <div>{varChildrenInfo.bh_company}</div>
                </li>
              </ul>
            </div>
            {/* 발급신청 */}
            <div className="certi-box">
              <div className="certi-input-box">
                <div className="input-line">
                  <select name="vl_idx" value={varChildrenInfo.vl_idx} onChange={e=>onChangeInputHandler(e)}>
                    <option value={0}>발급대상 선택</option>
                    {varChildrenLevelList.map((levels,i)=>(
                      <option key={'levels_'+i} value={levels.vl_idx}>{levels.vl_name}</option>
                    ))}
                  </select>
                </div>
                <div className="input-line">
                  <div className="chk-box">
                    <input type="radio" value={1} name="ce_lang" id="ce_lang1" checked={varChildrenInfo.ce_lang===1} onChange={e=>onChangeInputHandler(e)}/>
                    <label htmlFor="ce_lang1">&nbsp;국문</label>
                  </div>
                  {varChildrenInfo.vl_idx===1?null:
                    <div className="chk-box">
                      <input type="radio" value={2} name="ce_lang" id="ce_lang2" checked={varChildrenInfo.ce_lang===2} onChange={e=>onChangeInputHandler(e)}/>
                      <label htmlFor="ce_lang2">&nbsp;영문</label>
                    </div>
                  }
                  {varChildrenInfo.vl_idx===1?null:
                    <div className="chk-box">
                      <input type="radio" value={3} name="ce_lang" id="ce_lang3" checked={varChildrenInfo.ce_lang===3} onChange={e=>onChangeInputHandler(e)}/>
                      <label htmlFor="ce_lang3">&nbsp;국문/영문</label>
                    </div>
                  }
                </div>
                {varChildrenInfo.ce_lang===2?null:
                  <div className="input-line">
                    <input type="text" value={varChildrenInfo.ch_name||""} name="ch_name" placeholder="원아명" onChange={e=>onChangeInputHandler(e)}/>
                  </div>
                }
                {varChildrenInfo.ce_lang===1?null:
                  <div className="input-line">
                    <input type="text" value={varChildrenInfo.ch_ename||""} name="ch_ename"  placeholder="영문 원아명" onChange={e=>onChangeInputHandler(e)}/>
                  </div>
                }
                <div className="input-line">
                  <div className="has-btn">
                    <input type="text" value={ChangeDateStringOnlyDate(varChildrenInfo.ce_idate)||""} name="ce_idate" className="input-cal" disabled/>
                    <button className="cal-btn"onClick={e=>onChangeDateHandler(e)}><img src={centerIcon} alt=""/></button>
                  </div>
                </div>
                {varChildrenInfo.ce_lang===2?null:
                  <div className="input-line">
                    <input type="text" value={varChildrenInfo.bh_company||""} name="bh_company" placeholder="센터명" onChange={e=>onChangeInputHandler(e)}/>
                  </div>
                }
                {varChildrenInfo.ce_lang===1?null:
                  <div className="input-line">
                    <input type="text" value={varChildrenInfo.bh_ecompany||""} name="bh_ecompany" placeholder="영문센터명" onChange={e=>onChangeInputHandler(e)}/>
                  </div>
                }

              </div>
            </div>
            <div className="form-contoller bt-btn">
              <Link className="form-contoller-btn btn-no" style={{width:"48%"}} to={'/Branch/CertificatesSet'}>취소</Link>
              <button className="form-contoller-btn btn-yes" onClick={e=>onRegisterCertificateHandler(e)}>확인</button>
            </div>
          </div>
        </div>
      </div>
      <SelectDateOnly varStudyIndex={0} varDate={varDate} setDate={setDate} varPopupDaySelect={varPopupDaySelect} 
                        TogglePopupDaySelect={TogglePopupDaySelect} ChangedDate={ChangedDate}/>
    </div>	
  );
}
export default CertificateOrder;